module.exports = __webpack_public_path__ + "img/video-back.b31d0652.png";